module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-data.9758710f.png";